import { render, staticRenderFns } from "./Productos.vue?vue&type=template&id=ef9e744c"
import script from "./Productos.vue?vue&type=script&lang=ts"
export * from "./Productos.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports